import React, { useEffect } from "react";

import AuthRouter from "./AuthRouter";
import AppRouter from "./AppRouter";

import { Layout } from "antd";
import Navigation from "@/layout/Navigation";

import { useDispatch, useSelector } from "react-redux";
import {
  selectAuth,
  selectAuthCurrent,
  selectUserNotifications,
} from "@/redux/auth/selectors";
import { isSidebarVisible } from "@/redux/page/selector";
import socket from "@/utils/socketHelper";
import {
  addNotification,
  getAllNotificationsByUser,
} from "@/redux/auth/actions";
import * as actionTypes from "../redux/auth/types";
import store from "@/redux/store";
import { useRoleChecker } from "@/hooks/UseRoleChecker";
import { roles } from "@/utils/constant";

export default function Router() {
  const { isLoggedIn } = useSelector(selectAuth);
  const showSideBar = useSelector(isSidebarVisible);
  const current = useSelector(selectAuthCurrent);
  const dispatch = useDispatch();
  const { shopProfile } = useSelector((state) => state?.auth);
  const isShopOwner = useRoleChecker(roles.SHOPOWNER);

  const replaceNotifications = (data) => {
    const state = store.getState();
    const _notifications = [...state?.auth?.notifications];
    const index = _notifications?.findIndex((item) => item?._id === data?._id);

    if (index > -1) {
      _notifications.splice(index, 1);
      _notifications.unshift(data);
      dispatch({
        type: actionTypes.SET_NOTIFICATIONS,
        payload: _notifications,
      });
      return true;
    }
    return false;
  };

  useEffect(() => {
    socket.on("notification", (data) => {
      if (isShopOwner && (shopProfile?.poc?.findIndex((user)=> user?._id === data.notificationUser ) !== -1) && current.user.id === data.notificationUser){
        if (!replaceNotifications(data)) {
          dispatch(addNotification(data)); // Store in Redux
        }
      }
      else if (current.user.id === data.notificationUser) {
        if (!replaceNotifications(data)) {
          dispatch(addNotification(data)); // Store in Redux
        }
      }
    });

    return () => {
      socket.off("notification");
    };
  }, []);

  useEffect(() => {
    if (isLoggedIn) {
      dispatch(getAllNotificationsByUser(current.user.id)).then((res) => {
        if (res?.success) {
          dispatch({
            type: actionTypes.SET_NOTIFICATIONS,
            payload: res?.userNotifications,
          });
        }
      });
    }
  }, [isLoggedIn]);

  if (isLoggedIn === false)
    return (
      <Layout style={{ minHeight: "100vh" }}>
        <AuthRouter />
      </Layout>
    );
  else
    return (
      <Layout style={{ minHeight: "100vh" }}>
        {showSideBar && <Navigation />}
        <Layout style={{ minHeight: "100vh" }}>
          {/* <NavigationBar /> */}
          {/* <HeaderContent /> */}
          <AppRouter />
        </Layout>
      </Layout>
    );
}

// export default App;
